import {Integer, ValueByDevice} from 'platform/foundation';

import {prop} from 'ramda';

import {DashboardTileCoordinates} from '../types/DashboardTileCoordinates';
import {DashboardTileSize} from '../types/DashboardTileSize';
import {DASHBOARD_TILE_SIZES} from './dashboardTileSizes';

interface DashboardGridCell extends DashboardTileCoordinates {
  size: DashboardTileSize;
}

export interface DashboardGridPlacement {
  span: ValueByDevice<Integer>;
  rowSpan: ValueByDevice<Integer>;
  columnStart: ValueByDevice<number | undefined>;
  rowStart: ValueByDevice<number | undefined>;
}

const FIRST_TRACK = 1;

export function toDashboardGridPlacement(cell: DashboardGridCell): DashboardGridPlacement {
  const size = prop(cell.size, DASHBOARD_TILE_SIZES);
  const columnStart = cell.column + FIRST_TRACK;
  const rowStart = cell.row + FIRST_TRACK;

  return {
    span: [1, size.columns, size.columns, size.columns],
    rowSpan: [1, size.rows, size.rows, size.rows],
    columnStart: [undefined, columnStart, columnStart, columnStart],
    rowStart: [undefined, rowStart, rowStart, rowStart],
  };
}
